import React, { useState } from "react";
import Card from "components/card";
import { createProject, uploadProjectImage } from "services/projects";
import { useToast } from "components/Toast";
import { useNavigate } from "react-router-dom";

const CreateProject: React.FC = () => {
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { data } = await createProject({ title, summary });
      if (file) {
        const fd = new FormData();
        fd.append("image", file);
        await uploadProjectImage(data.id, fd);
      }
      navigate("/admin/projects");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to create project");
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Create Project</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm">Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm">Summary</label>
          <textarea
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm">Image</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          />
        </div>
        <div>
          <button
            type="submit"
            className="rounded bg-indigo-600 px-4 py-2 text-white"
          >
            Create
          </button>
        </div>
      </form>
    </Card>
  );
};

export default CreateProject;
// (removed duplicate placeholder)
